import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

import { authReducer } from './auth/authSlice';
import { usersReducer } from './users/usersSlice';
import { locationsReducer } from './locations/locationsSlice';
import { passengersReducer } from './passengers/passengersSlice';
import { logout } from './auth/operations';

const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['token'],
};

// Комбінований редюсер
const appReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  users: usersReducer,
  locations: locationsReducer,
  passengers: passengersReducer,
});

// Головний редюсер, який обробляє скидання стейту при Logout
const rootReducer = (state, action) => {
  if (action.type === logout.fulfilled.type) {
    // Очищення всього стейту, окрім auth
    state = {
      auth: state.auth, // зберігаємо auth, якщо це необхідно
    };
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
